module.exports = __webpack_public_path__ + "static/media/4-square-dirty.49bfdf43.svg";